const ARICA_PARINACOTA = 'Región de Arica y Parinacota';
const TARAPACA = 'Región de Tarapacá';
const ANTOFAGASTA = 'Región de Antofagasta';
const ATACAMA = 'Región de Atacama';
const COQUIMBO = 'Región de Coquimbo';
const VALPARAISO = 'Región de Valparaíso';
const METROPOLITANA = 'Región Metropolitana';
const OHIGGINS = "Región de O'Higgins";
const MAULE = 'Región del Maule';
const NUBLE = 'Región del Ñuble';
const BIOBIO = 'Región del Biobío';
const ARAUCANIA = 'Región de la Araucanía';
const LOS_RIOS = 'Región de Los Ríos';
const LOS_LAGOS = 'Región de Los Lagos';
const AYSEN = 'Región de Aysén';
const MAGALLANES = 'Región de Magallanes';

const REGIONS = [
  ARICA_PARINACOTA,
  TARAPACA,
  ANTOFAGASTA,
  ATACAMA,
  COQUIMBO,
  VALPARAISO,
  METROPOLITANA,
  OHIGGINS,
  MAULE,
  NUBLE,
  BIOBIO,
  ARAUCANIA,
  LOS_RIOS,
  LOS_LAGOS,
  AYSEN,
  MAGALLANES,
];

module.exports = {
  ARICA_PARINACOTA,
  TARAPACA,
  ANTOFAGASTA,
  ATACAMA,
  COQUIMBO,
  VALPARAISO,
  METROPOLITANA,
  OHIGGINS,
  MAULE,
  NUBLE,
  BIOBIO,
  ARAUCANIA,
  LOS_RIOS,
  LOS_LAGOS,
  AYSEN,
  MAGALLANES,
  REGIONS,
};
